import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Page } from "@/components/layout";
import { useSession } from "@/hooks/useSession";
import { navigateToSessionResume } from "@/lib/chatNavigation";
/**
 * Deeplink `/history/session/:sessionId`: re-opens the saved thread at the backend and redirects
 * into the active mentor/chat UI so the user can pick up where they left off.
 */
export const SessionHistoryPage = () => {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const { reopenSessionFromHistory } = useSession();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!sessionId) {
      setFailed(true);
      return;
    }

    let cancelled = false;

    void (async () => {
      const session = await reopenSessionFromHistory(sessionId);
      if (cancelled) return;
      if (session) {
        navigateToSessionResume(navigate, session, true);
      } else {
        setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [sessionId, reopenSessionFromHistory, navigate]);

  return (
    <Page.Container className="animate-fade-in">
      <Page.Header>
        <h1 className="text-3xl font-semibold text-white font-literata">{failed ? "Can't open conversation" : "Opening conversation"}</h1>
        {!failed && <p className="text-white/75 font-inter text-sm">Taking you back to chat…</p>}
      </Page.Header>

      <Page.Content className="flex flex-col flex-1 gap-6">
        {failed ? (
          <p className="text-white/85 font-inter text-center">
            This session could not be opened.{" "}
            <Link to="/history" className="text-bodhi-gold underline-offset-4 hover:underline">
              Back to History
            </Link>
          </p>
        ) : (
          <div className="flex flex-1 justify-center pt-16">
            <Loader2 className="h-10 w-10 animate-spin text-white" aria-label="Loading" />
          </div>
        )}
      </Page.Content>
    </Page.Container>
  );
};
